import React from 'react';
import { flexRender, Table } from '@tanstack/react-table';
import Filter from '../Filters/Filters';

type Props = {
	table: Table<unknown>;
};
const TableHeader = ({ table }: Props) => {
	return (
		<thead>
			{table.getHeaderGroups().map((headerGroup) => (
				<tr key={headerGroup.id}>
					{headerGroup.headers.map((header) => (
						<th key={header.id}>
							{header.isPlaceholder ? null : (
								<div className="d-flex justify-content-between">
									<div
										className={header.column.getCanSort() ? 'cursor-pointer select-none' : ''}
										onClick={header.column.getToggleSortingHandler()}
										title={
											header.column.getCanSort()
												? header.column.getNextSortingOrder() === 'asc'
													? 'Sort ascending'
													: header.column.getNextSortingOrder() === 'desc'
														? 'Sort descending'
														: 'Clear sort'
												: undefined
										}>
										{flexRender(header.column.columnDef.header, header.getContext())}
										{{
											asc: <span className="ms-1 glyphicons-arrow-thin-down arrow-sorted" />,
											desc: <span className="glyphicons-arrow-thin-up arrow-sorted" />,
										}[header.column.getIsSorted() as string] ?? null}
									</div>
									{header.column.getCanFilter() ? (
										<div>
											<Filter column={header.column} />
										</div>
									) : null}
								</div>
							)}
						</th>
					))}
				</tr>
			))}
		</thead>
	);
};

export default TableHeader;
